const VehicleSchema = {
    sequence: null,
    dataSource: null,
    isVehicleVerified: true,
    isVehicleActiveDuringMostRecentTerm: false,
    year: null,
    make: null,
    model: null,
    vin: null,
    registeredOwnerName: {
      "givenName": null,
      "surname": null
    },
    nameTitle1: {
      code: null,
      description: ""
    },
    nameCode2: {
      code: null,
      description: "Unused"
    },
    numberofVehicleOwners: null,
    businessUse: null,
    classCode: null,
    collisionDeductibleAmount:null,
    comprehensiveDeductibleAmount: null,
    fromDate: null,
    toDate: null,
    collisionIndicator: "N",
    comprehensiveIndicator: "N",
    coverages: [],
    isVehicleSalvage: false,
    transactionDate: null,
    expirationDate: null,
    activityDate: null,
    lesseeLessor: {
      "code": "0",
      "description": "Name unassigned / address unassigned"
    },
    documentType: {
      code: "2",
      description: "Registration"
    },
    isBranded: false,
    plateType: {
      code: null,
      description: ""
    },
    isVINValid: false,
    vinChangeIndicator: {
      code: null,
      description: ""
    },
    "vinCompare": {
      code: "N",
    },
    supplementalCatClaimIndicator: "N",
    addresses: [{        
        street1: null,
        city: null,
        stateCode: null,
        zip: null,
        addressType: null
    }],
    stateOfRegistration: null,
    reasonCodeDetails: [],
    actionMessages: [],
    uniqueId: null
  }

  export default VehicleSchema;


// WEBPACK FOOTER //
// ./src/Vehicle/store.js